function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 37.5c-9.665 0-17.5-7.835-17.5-17.5S10.335 2.5 20 2.5 37.5 10.335 37.5 20 29.665 37.5 20 37.5z",
  fill: "#262626",
  opacity: 0.647
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 0c11.045 0 20 8.954 20 20s-8.955 20-20 20C8.954 40 0 31.045 0 20 0 8.954 8.954 0 20 0zm0 2.5C10.335 2.5 2.5 10.335 2.5 20S10.335 37.5 20 37.5 37.5 29.665 37.5 20 29.665 2.5 20 2.5zm-7.928 9.537a1.253 1.253 0 011.78 0l6.613 6.626 6.517-6.474a1.266 1.266 0 011.779 0 1.239 1.239 0 010 1.765l-6.526 6.482 6.563 6.574c.491.494.491 1.294.002 1.786a1.253 1.253 0 01-1.78 0l-6.572-6.583-6.633 6.588a1.266 1.266 0 01-1.78 0 1.241 1.241 0 010-1.765l6.641-6.596-6.604-6.616a1.268 1.268 0 010-1.787z",
  fill: "#FFF"
}));

function SvgMoreViewsClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMoreViewsClose;